var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-tabs',[_c('b-tab',{attrs:{"title":"Карти клиєнтів"}},[_c('clients-with-cards')],1),_c('b-tab',{attrs:{"title":"Дні народження"}},[_c('birthday-list')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }